import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useProcessDefinitions({ enabled = true, params }) {
  return useQuery({
    enabled,
    queryKey: ["process-definitions", params],
    queryFn: async () =>
      customFetch(
        `/api/smartbpm/v1/{tenant}/process-definitions?${new URLSearchParams(params)}`,
      ),
  });
}

export function useProcessDefinition({ enabled = true, id }) {
  return useQuery({
    enabled,
    queryKey: ["process-definition", id],
    queryFn: async () =>
      customFetch(`/api/smartbpm/rest/process-definition/${id}/xml`),
  });
}

export function useProcessDefinitionVersions({ enabled = true, key, params }) {
  return useQuery({
    enabled,
    queryKey: ["process-definitions", key, "versions"],
    queryFn: async () =>
      customFetch(
        `/api/smartbpm/v1/{tenant}/process-definitions?${new URLSearchParams(params)}`,
      ),
  });
}
